import { useState } from "react";

// Quote a CSV field when it contains a comma, quote or line break (RFC 4180)
const escapeCsv = (value) => {
  const text = String(value ?? "");
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const useCsvDownloadHook = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  // summaryRows: optional rows appended after a blank line, each an array of cells
  const downloadCsv = (filename, fileData, headers = null, summaryRows = []) => {
    if (!fileData || fileData.length === 0) return;

    setIsDownloading(true);

    // Determine headers: array of objects [{ label, key }] OR array of strings
    let csvHeaders =
      headers && headers.length > 0
        ? headers.map(h => (typeof h === "string" ? h : h.label)) // Extract labels if objects
        : Object.keys(fileData[0]); // Auto-detect from fileData

    let csvRows = fileData.map(row =>
      csvHeaders.map(h => {
        const key = headers && headers.length > 0
          ? headers.find(hdr => hdr.label === h)?.key || h  // Match key from label
          : h;
        return escapeCsv(row[key]);
      }).join(",")
    );

    const summaryLines = summaryRows.length
      ? ["", ...summaryRows.map(row => row.map(escapeCsv).join(","))]
      : [];

    const csvContent = [csvHeaders.map(escapeCsv).join(","), ...csvRows, ...summaryLines].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download.csv";

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => {
      setIsDownloading(false);
      URL.revokeObjectURL(url); // Cleanup
    }, 2000);
  };

  return { isDownloading, downloadCsv };
};

export default useCsvDownloadHook;
